import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getRequestToken } from './../../actions';

const LoginButton = ({getRequestToken}) => {
  return (
    <a className="btn btn-danger btn-m pull-right" onClick={getRequestToken}>
      <div className="icon-m__white pull-left" />&nbsp;Login
    </a>
  );
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ getRequestToken }, dispatch);
}

export default connect(undefined, mapDispatchToProps)(LoginButton);



// WEBPACK FOOTER //
// ./src/containers/NavOptions/LoginButton.js